export default __webpack_public_path__ + "images/search_be66e45499552f20f09bae7991815d48.svg";